import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import Select from 'react-select';
import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';


const FullOrderView = () => {
 
  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');
  const [prescriptionImage, setPrescriptionImage] = useState('');
  const [prescriptionLoading, setPrescriptionLoading] = useState(false);
  const [orderSaving, setOrderSaving] = useState(false);
  const [orderForm, setOrderForm] = useState({
    fullname: "",
    phone: "",
    email: "",
    address: "",
    pincode: "",
    bookingDate: "",
    bookingTime: "",
    requirement: "",
  });

  const { userId, id } = useParams();

  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
 
  const navigate = useNavigate();

  const saveAsPDF = async () => {
    const printContent = document.getElementById('print');

    // Set the scale factor for better quality
    const scale = 5;

    // Set the quality of the JPEG image
    const imageQuality = 1; // 1 is maximum quality

    // Convert print content to image with higher scale
    html2canvas(printContent, {
      scale: scale,
      useCORS: true, // Enable CORS to support loading images from different origins
      logging: true // Enable logging for debugging
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', imageQuality); // Use JPEG format with specified quality

      // Calculate dimensions of PDF page
      const pdfWidth = 297; // A4 width in mm
      const pdfHeight = 210; // A4 height in mm
      const ratio = canvas.width / canvas.height;

      let pdfHeightAdjusted = pdfHeight;
      let pdfWidthAdjusted = pdfWidth;

      if (ratio < pdfWidth / pdfHeight) {
        pdfWidthAdjusted = pdfHeight * ratio;
      } else {
        pdfHeightAdjusted = pdfWidth / ratio;
      }

      // Create a new jsPDF instance
      const pdf = new jsPDF({
        orientation: 'landscape', // Set the orientation of the PDF to landscape
        unit: 'mm', // Use millimeters as the unit for measurements
        format: [pdfWidth, pdfHeight] // Set the format of the PDF (A4 size)
      });

      // Add image to PDF document
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidthAdjusted, pdfHeightAdjusted);

      // Save the PDF
      pdf.save("invoice.pdf");
    });
  }

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const getDetailsFromOrder = (order) => {
    if (Array.isArray(order?.details)) {
      return order.details[0] || {};
    }

    return order?.details || {};
  };

  const getItemsFromOrder = (order) => Array.isArray(order?.items) ? order.items : [];

  const getFirstItemFromOrder = (order) => getItemsFromOrder(order)[0] || {};

  const getValueFromOrder = (order, key) =>
    order?.[key] || getDetailsFromOrder(order)?.[key] || getFirstItemFromOrder(order)?.[key] || "";

  const getDateInputValue = (dateString) => {
    if (!dateString) return "";
    return String(dateString).slice(0, 10);
  };

  const getUserOrders = async () => {

    try {
      // const id = localStorage.getItem('userId');
      const { data } = await axiosInstance.get(`/user-orders-view/${id}`);

      if (data?.success) {
        console.log('order', data)
        const order = data?.userOrder;
        setOrder(order);
        setPrescriptionImage(order?.prescriptionImage || '');
        setOrderForm({
          fullname: getValueFromOrder(order, "fullname") || getValueFromOrder(order, "username"),
          phone: getValueFromOrder(order, "phone"),
          email: getValueFromOrder(order, "email"),
          address: getValueFromOrder(order, "address"),
          pincode: getValueFromOrder(order, "pincode"),
          bookingDate: getDateInputValue(getValueFromOrder(order, "bookingDate")),
          bookingTime: getValueFromOrder(order, "bookingTime"),
          requirement: getValueFromOrder(order, "requirement"),
        });

      }
      setIsLoading(false); // Set loading state to false after fetching data

    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error
      toast.error("order Not found");
      navigate('/all-order');
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleOrderFormChange = (event) => {
    const { name, value } = event.target;
    setOrderForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleOrderDetailsSave = async () => {
    try {
      setOrderSaving(true);
      const { data } = await axiosInstance.put(`/admin/update-order/${id}`, orderForm);

      if (data?.success) {
        setOrder(data?.updatedOrder || data?.updatedData || Order);
        toast.success("Order details updated!");
        getUserOrders();
      }
    } catch (error) {
      console.error("Error updating order details:", error);
      toast.error(error?.response?.data?.message || "Error updating order details");
    } finally {
      setOrderSaving(false);
    }
  };

  const getUploadedImageUrl = (uploadedPath) => {
    if (!uploadedPath) return "";
    if (/^https?:\/\//i.test(uploadedPath)) return uploadedPath;

    const cleanBaseUrl = weburl.replace(/\/$/, "");
    if (uploadedPath.startsWith("/")) {
      return `${cleanBaseUrl}${uploadedPath}`;
    }

    return `${cleanBaseUrl}/uploads/${uploadedPath}`;
  };

  const savePrescriptionImage = async (selectedImage) => {
    try {
      setPrescriptionLoading(true);
      const { data } = await axiosInstance.put(`/admin/update-order-prescription/${id}`, {
        prescriptionImage: selectedImage,
      });

      if (data?.success) {
        setPrescriptionImage(selectedImage);
        setOrder((prevOrder) => ({
          ...prevOrder,
          prescriptionImage: selectedImage,
        }));
        toast.success("Prescription image updated!");
      }
    } catch (error) {
      console.error("Error updating prescription image:", error);
      toast.error(error?.response?.data?.message || "Error updating prescription image");
    } finally {
      setPrescriptionLoading(false);
    }
  };

  const handlePrescriptionUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.error("Please choose an image file");
      event.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("title", file.name);

    try {
      setPrescriptionLoading(true);
      const { data } = await axiosInstance.post("/admin/upload-img", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!data?.success) {
        toast.error(data?.message || "Error uploading prescription image");
        return;
      }

      const uploadedImage = getUploadedImageUrl(data.imageUrl || data.filePath || data.image?.filePath);
      if (!uploadedImage) {
        toast.error("Prescription uploaded, but image path was not returned");
        return;
      }

      await savePrescriptionImage(uploadedImage);
    } catch (error) {
      console.error("Error uploading prescription image:", error);
      toast.error(error?.response?.data?.message || "Error uploading prescription image");
    } finally {
      setPrescriptionLoading(false);
      event.target.value = "";
    }
  };


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  const getOrderDetails = () => {
    if (Array.isArray(Order?.details)) {
      return Order.details[0] || {};
    }

    return Order?.details || {};
  };

  const getOrderItems = () => Array.isArray(Order?.items) ? Order.items : [];

  const getFirstOrderItem = () => getOrderItems()[0] || {};

  const getOrderValue = (key) => Order?.[key] || getOrderDetails()?.[key] || getFirstOrderItem()?.[key] || "";

  const getOrderVendor = () => Order?.asignId || {};

  const getItemVendor = () => getOrderItems().find((item) => item?.vendorName || item?.vendorPhone || item?.vendorId) || {};




  useEffect(() => {

    getUserOrders();

  }, []);



  return (
    <>
      <Sidebar />
      <main class="content">
        <Navbar />

        <div className="pt-4 px-5">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                OrderID #{Order.orderId}
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">
          
          <div>
              {" "}
              <Link
                to="/all-order"
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>


            <button onClick={saveAsPDF} className="btn btn-primary py-1">
              <i className="bi bi-download" />{" "}
              <span className="text">Invoice</span>
            </button>

          </div>
        </div>

        <div id="main-content" className="bg-transparent ">

          {isLoading ? (
            // Display loading skeletons while data is being fetched
            Array.from({ length: 2 }).map((_, index) => (
              <div className="col-md-12" key={index}>

                <div className="skeleton mb-3" style={{ height: 154, borderRadius: 2 }} />

              </div>
            ))
          ) :
            (<>

<div className='container mt-4 row mx-auto'>
   {/* Name input */}
   <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={orderForm.fullname}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
                {/* Email input */}
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={orderForm.phone}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={orderForm.email}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
				
				
  <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5address">
                  Full Address
                    <span className="text-danger"> (Required )</span>
                  </label>
                  
                   <textarea
                    type="text"
                    id="address"
                    className="form-control"
                    name="address"
                    value={orderForm.address}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />

                </div>

                <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Pincode
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className="form-control"
                    name="pincode"
                    value={orderForm.pincode}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
 

 <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                  Booking Date
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="date"
                    id="form5Example2"
                    className="form-control"
                    name="bookingDate"
                    value={orderForm.bookingDate}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
 
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                     Booking Time
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="time"
                    id="form5Example2"
                    className="form-control"
                    name="bookingTime"
                    value={orderForm.bookingTime}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

  <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Requirement{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                    type="text"
                    id="requirement"
                    className="form-control"
                    name="requirement"
                    value={orderForm.requirement}
                    onChange={handleOrderFormChange}
                    style={{ boxShadow: "none" }}
                  />
                 
                </div>  

                <div className="col-md-12 mb-4">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleOrderDetailsSave}
                    disabled={orderSaving}
                  >
                    {orderSaving ? "Saving..." : "Save Order Details"}
                  </button>
                </div>

                <div className="col-md-12 mb-4">
                  <h5 className="mb-3">Vendor Details</h5>
                  <div className="border rounded p-3 bg-white">
                    {getOrderVendor()?.username || getItemVendor()?.vendorName ? (
                      <>
                        <h6 className="mb-2">{getOrderVendor()?.username || getItemVendor()?.vendorName}</h6>
                        {(getOrderVendor()?.phone || getItemVendor()?.vendorPhone) && (
                          <p className="mb-1"><strong>Phone:</strong> {getOrderVendor()?.phone || getItemVendor()?.vendorPhone}</p>
                        )}
                        {getOrderVendor()?.email && (
                          <p className="mb-1"><strong>Email:</strong> {getOrderVendor()?.email}</p>
                        )}
                        {(getOrderVendor()?.companyName || getOrderVendor()?.company) && (
                          <p className="mb-1"><strong>Company:</strong> {getOrderVendor()?.companyName || getOrderVendor()?.company}</p>
                        )}
                        {getOrderVendor()?.address && (
                          <p className="mb-0"><strong>Address:</strong> {getOrderVendor()?.address}</p>
                        )}
                      </>
                    ) : (
                      <p className="mb-0 text-muted">No vendor assigned.</p>
                    )}
                  </div>
                </div>

                <div className="col-md-12 mb-4">
                  <h5 className="mb-3">Product Details</h5>
                  {getOrderItems().length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered align-middle">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getOrderItems().map((item, index) => (
                            <tr key={item.id || item.pid || index}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  {item.image && (
                                    <img
                                      src={item.image}
                                      alt={item.title || "Product"}
                                      style={{ width: 48, height: 48, objectFit: "cover" }}
                                    />
                                  )}
                                  <div>
                                    <strong>{item.title || item.name || "Product"}</strong>
                                    {item.slug && <span className="d-block small text-muted">{item.slug}</span>}
                                  </div>
                                </div>
                              </td>
                              <td>{item.quantity || item.TotalQuantity || 1}</td>
                              <td>₹{item.price || item.salePrice || 0}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-muted">No product details found.</p>
                  )}
                </div>
				
                <div className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="prescription-image-upload">
                    Prescription Image
                  </label>
                  <div className="mb-3">
                    <img
                      src={prescriptionImage || "/assets/images/placeholder.png"}
                      id="prescription-image-preview"
                      alt="Prescription"
                      className="d-block border rounded mb-3"
                      style={{ maxHeight: 220, maxWidth: 280, objectFit: "contain" }}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control"
                      id="prescription-image-upload"
                      name="prescriptionImage"
                      onChange={handlePrescriptionUpload}
                      disabled={prescriptionLoading}
                    />
                  </div>
                  {prescriptionImage && (
                    <a
                      href={prescriptionImage}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm btn-outline-primary me-2"
                    >
                      View Prescription
                    </a>
                  )}
                  {prescriptionLoading && <span className="text-muted small">Uploading...</span>}
                </div>
				
				

 
</div>





            </>)}





        </div>


      </main>
    </>
  )
}

export default FullOrderView
